<template>
  <main
    class="
      bg-white
      dark:bg-black
      dark:text-white
      col-start-1
      pl-4
      md:pl-8
      lg:pl-0
      lg:col-start-3
      col-end-13
      relative
      z-10
    "
    v-if="media"
  >
    <grid-letters text="media" />
    <div class="relative z-10 pb-8">
      <div
        v-if="media.podcasts && media.podcasts.length > 0"
        class="pt-4 md:pt-8 mb-4 flex overflow-x-auto"
      >
        <div class="w-1/5 flex-0" @mousemove="changeCursor('')">PODCASTS</div>
        <router-link
          :to="{ name: 'mediaitem', params: { id: item.uid } }"
          v-for="item in media.podcasts"
          :key="item.uid"
          class="
            mr-4
            h-48
            bg-gray-400
            w-1/3
            lg:w-1/6
            flex-0 flex
            justify-center
            items-center
            text-black
          "
        >
          <div
            @mousemove="changeCursor('LISTEN')"
            @mouseleave="changeCursor('')"
            class="
              w-full
              bg-gray-400
              h-full
              flex
              justify-center
              items-center
              text-black
              relative
              lg:cursor-none
            "
          >
            <div class="text-center z-10 relative uppercase">
              {{ item.title }}
              <br />
              <img
                class="inline-block"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiBjbGFzcz0iaWNvbmlmeSBpY29uaWZ5LS1ieCIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9InRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7Ij48cGF0aCBkPSJNNyA2djEybDEwLTZ6IiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48L3N2Zz4="
                alt="Listen"
              />
            </div>
            <img
              v-if="item.cover"
              class="absolute w-full h-full object-cover"
              :src="item.cover.url"
            />
          </div>
        </router-link>
        <div class="w-1/6 flex-0"></div>
      </div>

      <div class="pt-4 md:pt-8 mb-4 flex">
        <div class="flex-0 w-1/5">VIDEOS</div>
        <div class="flex flex-wrap flex-1">
          <router-link
            :to="{ name: 'mediaitem', params: { id: item.uid } }"
            v-for="item in media.videos"
            :key="item.uid"
            class="pr-4 text-white w-full lg:w-1/2 flex-0 mb-4"
          >
            <div
              @mousemove="changeCursor('WATCH')"
              @mouseleave="changeCursor('')"
              class="
                w-full
                bg-gray-400
                h-80
                flex
                justify-center
                items-center
                text-black
                relative
                lg:cursor-none
              "
            >
              <div class="text-center z-10 relative uppercase">
                {{ item.title }}<br />
                <img
                  class="inline-block"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiBjbGFzcz0iaWNvbmlmeSBpY29uaWZ5LS1ieCIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9InRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7Ij48cGF0aCBkPSJNNyA2djEybDEwLTZ6IiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48L3N2Zz4="
                  alt="Listen"
                />
              </div>
              <img
                v-if="item.cover"
                class="absolute w-full h-full object-cover"
                :src="item.cover.url"
              />
            </div>
          </router-link>
        </div>
      </div>

      <div class="uppercase">
        <div v-if="info.facebook">
          <a
            :href="info.facebook"
            target="_blank"
            @mousemove="changeCursor('OPEN')"
            @mouseleave="changeCursor('')"
          >
            <img
              class="h-4 inline-block align-text-bottom pr-2"
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' aria-hidden='true' focusable='false' role='img' class='iconify iconify--bx' width='1em' height='1em' preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24' style='transform: rotate(360deg);'%3E%3Cpath d='M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8.615v-6.96h-2.338v-2.725h2.338v-2c0-2.325 1.42-3.592 3.5-3.592c.699-.002 1.399.034 2.095.107v2.42h-1.435c-1.128 0-1.348.538-1.348 1.325v1.735h2.697l-.35 2.725h-2.348V21H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z' fill='white'%3E%3C/path%3E%3C/svg%3E"
              alt="Facebook"
            />THE SOMETHING MACHINE
          </a>
        </div>
        <div v-if="info.instagram">
          <a
            :href="info.instagram"
            target="_blank"
            @mousemove="changeCursor('OPEN')"
            @mouseleave="changeCursor('')"
          >
            <img
              class="h-4 inline-block align-text-bottom pr-2"
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' aria-hidden='true' focusable='false' role='img' class='iconify iconify--bx' width='1em' height='1em' preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24' style='transform: rotate(360deg);'%3E%3Cpath d='M20.947 8.305a6.53 6.53 0 0 0-.419-2.216a4.61 4.61 0 0 0-2.633-2.633a6.606 6.606 0 0 0-2.186-.42c-.962-.043-1.267-.055-3.709-.055s-2.755 0-3.71.055a6.606 6.606 0 0 0-2.185.42a4.607 4.607 0 0 0-2.633 2.633a6.554 6.554 0 0 0-.419 2.185c-.043.963-.056 1.268-.056 3.71s0 2.754.056 3.71c.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632a6.584 6.584 0 0 0 2.185.45c.963.043 1.268.056 3.71.056s2.755 0 3.71-.056a6.59 6.59 0 0 0 2.186-.419a4.615 4.615 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.187c.043-.962.056-1.267.056-3.71c-.002-2.442-.002-2.752-.058-3.709zm-8.953 8.297c-2.554 0-4.623-2.069-4.623-4.623s2.069-4.623 4.623-4.623a4.623 4.623 0 0 1 0 9.246zm4.807-8.339c-.597 0-1.078-.482-1.078-1.078a1.077 1.077 0 1 1 2.155 0c0 .596-.482 1.078-1.077 1.078z' fill='white'%3E%3C/path%3E%3Ccircle cx='11.994' cy='11.979' r='3.003' fill='white'%3E%3C/circle%3E%3C/svg%3E"
              alt="Instagram"
            />@THESOMETHINGMACHINE</a
          >
        </div>
      </div>
      <div class="h-screen"></div>
    </div>
  </main>
</template>

<script>
import GridLetters from "@/components/GridLetters.vue";
import { mapState } from "vuex";
export default {
  name: "media",
  metaInfo: {
    title: "– Media",
  },
  components: {
    GridLetters,
  },
  data() {
    return {
      busy: false,
    };
  },
  computed: mapState(["media", "info"]),
  methods: {
    openPanel(index) {
      this.$refs.swiper[index].toggle();
    },
    openText(index) {
      this.$refs.text[index].toggle();
    },
    loadMore() {
      this.busy = true;
      let curPage = this.media.pagination.page;
      if (curPage < this.media.pagination.pages) {
        this.$store.dispatch("loadMedia", curPage + 1).then(() => {
          this.busy = false;
        });
      } else {
        this.busy = false;
      }
    },
    changeCursor(name) {
      this.$root.$emit("changeCursor", name);
    },
  },
};
</script>
